const es = {
  nav: {
    services: 'Servicios',
    work: 'Proyectos',
    results: 'Resultados',
    contact: 'Contacto',
  },
  hero: {
    eyebrow: 'Ingeniero de Software Senior',
    headlinePart1: 'De sistemas fragmentados a una',
    headlinePart2: 'plataforma unificada.',
    description:
      'Ayudo a empresas medianas y grandes a modernizar plataformas legacy, conectar sistemas fragmentados y construir software que escala con su negocio.',
    cta: 'Agendar una Llamada',
    tags: ['Java / Spring', 'AWS', 'React', 'Microservicios', 'Integración de IA'],
  },
  about: {
    title: 'Mi Ventaja',
    description:
      'Desarrollador Full Stack Senior con experiencia en telecomunicaciones, consultoría, manufactura, finanzas, servicios municipales y automatización empresarial.',
    yearsLabel: 'Años de Experiencia',
    effortLabel: 'Reducción de Esfuerzo Manual',
  },
  pain: {
    label: 'Suena familiar',
    title: '¿Te suena familiar?',
    items: [
      'Nuestros sistemas no se comunican entre sí — el equipo trabaja alrededor de eso todos los días.',
      'Tenemos software legacy que nadie quiere tocar.',
      'Hacemos cosas manualmente que deberían estar automatizadas desde hace años.',
      'Queremos aprovechar la IA pero no sabemos por dónde empezar.',
    ],
  },
  services: {
    sectionLabel: 'Soluciones',
    sectionTitle: 'Lo Que Entrego',
    learnMore: 'Ver más',
  },
  projects: {
    sectionTitle: 'Trabajo Reciente.',
    sectionDescription:
      'Sistemas reales diseñados y entregados para operaciones de negocio, servicios municipales, finanzas, automatización retail y salud.',
    previousLabel: 'Proyecto anterior',
    nextLabel: 'Proyecto siguiente',
  },
  projectModal: {
    projectSuffix: 'Proyecto',
    typeLabel: 'Tipo',
    roleLabel: 'Rol',
    roleValue: 'Diseño y desarrollo de solución',
    deliveryLabel: 'Entrega',
    deliveryValue: 'Resumen estático de portafolio',
    focusLabel: 'Enfoque',
    focusValue: 'Automatización empresarial',
    stackLabel: 'Stack',
    strategyTitle: 'Estrategia del proyecto',
    strategyText:
      'El objetivo fue reemplazar procesos manuales con una plataforma enfocada que hace más fácil controlar, medir y escalar las operaciones diarias.',
    strategyItems: [
      'Centralizar datos operativos y reducir trabajo manual duplicado.',
      'Proveer flujos por rol para las personas que operan el negocio.',
      'Generar reportes útiles para seguimiento y toma de decisiones.',
      'Mantener la solución adaptable y fácil de mantener ante cambios futuros.',
    ],
    quote:
      'El software útil debe hacer la operación más clara, rápida y fácil de auditar sin agregar complejidad innecesaria.',
    roleTitle: 'Ingeniero de Software',
    approachTitle: 'Enfoque de ingeniería',
    approachText:
      'Me enfoco en módulos claros, persistencia confiable, reportes útiles, flujos simples e integraciones prácticas con los dispositivos o servicios que requiere el negocio.',
    goalsTitle: 'Objetivos del proyecto',
    goalItems: [
      'Digitalizar operaciones centrales del negocio.',
      'Mejorar trazabilidad y reportes.',
      'Reducir control manual y dependencia de hojas de cálculo.',
      'Apoyar a usuarios diarios con pantallas y flujos prácticos.',
    ],
    resultsTitle: 'Resultados',
    resultItems: [
      'Módulos operativos adaptados al dominio del negocio.',
      'Reportes y exportaciones para visibilidad gerencial.',
      'Base reutilizable para crecimiento futuro de funcionalidades.',
      'Mejor control sobre usuarios, registros y transacciones.',
    ],
    relatedTitle: 'Proyectos relacionados',
    contactTitle: '¿Tienes un proyecto en mente? Hablemos',
    contactText: 'Ponte en contacto para ver cómo puedo ayudarte con tu proyecto.',
  },
  results: {
    label: 'Resultados comprobados',
    title: 'Resultados que hablan por sí solos',
    context:
      'Más de 10 años entregando software en producción en telecomunicaciones, consultoría, manufactura, finanzas y servicios municipales.',
    stats: [
      { value: 70, suffix: '%', label: 'Reducción de esfuerzo manual' },
      { value: 40, suffix: '%', label: 'Despliegues más rápidos' },
      { value: 60, suffix: '%', label: 'Menos tiempo de procesamiento' },
      { value: 6,  suffix: '+', label: 'Industrias atendidas' },
    ],
  },
  caseStudies: {
    label: 'Trabajo seleccionado',
    title: 'Proyectos',
    items: [
      {
        id: '1',
        industry: 'Seguros / Consultoría',
        title: 'Plataforma Aflac EverWell',
        summary: 'Plataforma de inscripción de misión crítica utilizada por agentes de Aflac a nivel nacional.',
        result: '12 funcionalidades entregadas · 70% de trabajo manual eliminado · 40% mejora en consultas',
      },
      {
        id: '2',
        industry: 'Manufactura',
        title: 'Migración a AWS Cloud',
        summary: 'Modernización de 4 aplicaciones legacy y construcción de 6 microservicios en AWS ECS.',
        result: '4 apps migradas · 6 microservicios desplegados · 40% más rápido en despliegues',
      },
      {
        id: '3',
        industry: 'Telecomunicaciones',
        title: 'Plataforma Java de Ventas',
        summary: 'Sistema de ventas y envíos de dispositivos utilizado por el equipo comercial a nivel nacional.',
        result: '25+ funcionalidades entregadas · 60% menos tiempo en facturas · equipo de 3 liderado',
      },
    ],
  },
  experience: {
    sectionTitle: 'Mi Experiencia Laboral',
    details: 'Detalles',
    keyContributions: 'Contribuciones Clave',
  },
  contact: {
    sectionLabel: 'Hablemos',
    sectionTitle: '¿Listo para hablar sobre tus sistemas?',
    formTitle: 'Cuéntame sobre el desafío',
    subtext: 'Cuéntame sobre el desafío. Te respondo con un panorama claro de lo que es posible.',
    location: 'Morelos, México',
    email: 'Emmanuel-Merida@outlook.com',
    network: 'LinkedIn',
    locationLabel: 'Ubicación',
    emailLabel: 'Correo Profesional',
    networkLabel: 'Red Profesional',
  },
  form: {
    namePlaceholder: 'Tu Nombre',
    companyPlaceholder: 'Tu Empresa',
    emailPlaceholder: 'Tu Correo',
    messagePlaceholder: 'Mensaje',
    serviceDefault: 'Elige un Servicio',
    serviceOptions: [
      'Integración de Sistemas',
      'Modernización de Plataforma',
      'Automatización Empresarial',
      'Integración de IA',
    ],
    submitBtn: 'Enviar Mensaje',
    sending: 'Enviando mensaje...',
    successMsg: 'Gracias, tu mensaje fue enviado.',
    errorMsg: 'No se pudo enviar el mensaje. Intenta de nuevo o escríbeme directamente.',
    validationMsg: 'Por favor completa los campos requeridos.',
  },
  blog: {
    sectionTitle: 'Publicaciones',
    sectionDescription:
      'Ideas sobre entrega de software, automatización empresarial, plataformas cloud e IA aplicada.',
    essayLabel: 'Ensayo',
    postDetails: 'Ver Publicación',
  },
  footer: {
    bio: 'Ingeniero de Software Senior especializado en modernización de plataformas, integración de sistemas e IA para empresas medianas y grandes.',
    navigation: 'Navegación',
    allServices: 'Servicios',
    contact: 'Contacto',
    footerContactDesc:
      'Para consultoría, software personalizado u oportunidades de ingeniería senior, envíame un correo.',
    links: {
      services: 'Servicios',
      work: 'Proyectos',
      results: 'Resultados',
      contact: 'Contacto',
    },
    services: [
      'Integración de Sistemas',
      'Modernización de Plataforma',
      'Automatización Empresarial',
      'Integración de IA',
    ],
    emailSending: 'Enviando...',
    emailSent: 'Correo enviado.',
    emailError: 'No se pudo enviar.',
    copyright: 'Copyright © 2026 Emmanuel Mérida Toledo. Todos los derechos reservados.',
  },
  cta: {
    title: '¿Necesitas un socio de ingeniería confiable para tu próxima plataforma?',
    button: 'Agendar una Llamada',
  },
  modal: {
    solutionLabel: 'Solución',
    typicalResult: 'Resultado típico',
    cta: 'Agendar llamada →',
    tabOverview: 'Resumen',
    tabProcess: 'Proceso',
    tabCapabilities: 'Capacidades',
    approachHeading: 'Mi enfoque',
    workProcessHeading: 'Proceso de trabajo',
    capabilitiesHeading: 'Qué entrego',
    visualEyebrow: 'Perfil del servicio',
    visualTitle: 'Capacidades prácticas de software',
    visualItems: ['Arquitectura', 'Automatización', 'Datos', 'IA'],
  },
  servicesData: [
    {
      id: '1',
      stat: { value: '70%', label: 'Reducción de trabajo manual' },
      title: 'Integración de Sistemas',
      description: 'Conecta tus plataformas, APIs y fuentes de datos para que tus operaciones funcionen como una sola.',
      des2: 'Diseño capas de integración que hacen que tus sistemas existentes se comuniquen limpiamente.',
      des3: 'Entregables típicos: API gateways, flujos orientados a eventos, pipelines de datos y middleware.',
      mainDescription: 'Tus sistemas fueron construidos en diferentes momentos, por diferentes equipos. Diseño capas de integración que eliminan esa fricción.',
      scopeDescription: 'El trabajo de integración abarca diseño de APIs, comunicación entre servicios, mapeo de datos, autenticación y monitoreo.',
      capabilities: [
        'Diseño de APIs REST y documentación de contratos.',
        'Integración orientada a eventos con Kafka o RabbitMQ.',
        'Sincronización de datos y resolución de conflictos.',
        'Autenticación y autorización entre servicios.',
        'Observabilidad y monitoreo de integraciones.',
      ],
      capabilitiesDescription: 'Cada proyecto de integración entrega contratos limpios, rutas de comunicación probadas y observabilidad para detectar problemas antes de que afecten las operaciones.',
      approach: 'Comienzo por mapear los flujos de datos actuales e identificar dónde se pierde o duplica información. Luego diseño la capa de integración para resolver causas raíz, no síntomas.',
      workProcess: [
        'Mapear sistemas existentes e identificar puntos de integración.',
        'Diseñar contratos de API y modelos de datos.',
        'Construir y probar las rutas de integración.',
        'Desplegar con monitoreo y documentar para el equipo.',
      ],
    },
    {
      id: '2',
      stat: { value: '40%', label: 'Despliegues más rápidos' },
      title: 'Modernización de Plataforma',
      description: 'Migra software legacy a arquitectura cloud-ready — sin detener tu negocio.',
      des2: 'Ayudo a equipos a modernizar plataformas que se han vuelto demasiado costosas o riesgosas de mantener.',
      des3: 'Experiencia incluye AWS ECS, microservicios, Docker, pipelines CI/CD y migraciones incrementales.',
      mainDescription: 'Las plataformas legacy te frenan y cuestan más de mantener. Ayudo a modernizar de forma incremental, manteniendo el sistema en producción mientras se reemplaza lo necesario.',
      scopeDescription: 'Los proyectos de modernización cubren evaluación de arquitectura, descomposición de servicios, contenedorización, despliegue en nube, CI/CD y transferencia de conocimiento.',
      capabilities: [
        'Evaluación de arquitectura y hoja de ruta de migración.',
        'Descomposición de servicios y diseño de microservicios.',
        'Contenedorización con Docker y orquestación con Kubernetes.',
        'Despliegue en AWS: ECS, RDS, Lambda, S3.',
        'Pipelines CI/CD e infraestructura como código.',
      ],
      capabilitiesDescription: 'Los proyectos de modernización entregan un plan por fases, migraciones incrementales que mantienen producción estable y una plataforma cloud-ready.',
      approach: 'Evalúo la plataforma actual, identifico las áreas de mayor riesgo y diseño un plan de migración incremental. Sin reescrituras totales — cada fase entrega software funcional.',
      workProcess: [
        'Evaluar arquitectura actual y definir alcance de migración.',
        'Diseñar arquitectura objetivo y modelo de despliegue.',
        'Migrar de forma incremental, fase por fase.',
        'Validar comportamiento y entregar al equipo.',
      ],
    },
    {
      id: '3',
      stat: { value: '70%', label: 'Reducción de trabajo manual' },
      title: 'Automatización Empresarial',
      description: 'Elimina procesos manuales y tareas repetitivas con flujos de trabajo inteligentes y confiables.',
      des2: 'Construyo herramientas de automatización que reemplazan el trabajo manual repetitivo con sistemas que se ejecutan solos.',
      des3: 'Ejemplos: reportes PDF, exportaciones Excel, control de caja, flujos de agendamiento, generación de documentos.',
      mainDescription: 'Los procesos manuales cuestan más de lo que crees. Mapeo tus flujos de trabajo, identifico qué puede automatizarse y construyo sistemas que manejan el trabajo repetitivo de forma confiable.',
      scopeDescription: 'Los proyectos de automatización involucran mapeo de procesos, diseño de motores de flujo, generación de reportes, integraciones de sistemas y capacitación de usuarios.',
      capabilities: [
        'Diseño e implementación de motores de flujo de trabajo.',
        'Generación automatizada de documentos y reportes.',
        'Control de caja y conciliación financiera.',
        'Seguimiento de inventario y ciclo de vida de activos.',
        'Integración con hardware: biométricos, RFID, códigos de barras.',
      ],
      capabilitiesDescription: 'Las soluciones de automatización eliminan la entrada manual de datos, reducen errores y dan visibilidad en tiempo real de los procesos de negocio.',
      approach: 'Documento el proceso actual para encontrar los pasos manuales de mayor costo, luego construyo la automatización que los reemplaza. Los resultados son medibles desde el primer día.',
      workProcess: [
        'Mapear flujos actuales e identificar cuellos de botella.',
        'Diseñar flujo automatizado y modelo de datos.',
        'Construir y probar con datos reales del negocio.',
        'Capacitar usuarios y monitorear para optimizaciones.',
      ],
    },
    {
      id: '4',
      stat: { value: '60%', label: 'Menos tiempo de procesamiento' },
      title: 'Integración de IA',
      description: 'Agrega capacidades de IA prácticas a tus operaciones existentes. Sin hype, solo resultados utilizables.',
      des2: 'Desarrollo y despliego herramientas de IA que resuelven problemas específicos del negocio, no demos.',
      des3: 'Trabajo incluye integración de LLMs, pipelines NLP, modelos de clasificación y flujos de datos.',
      mainDescription: 'La IA funciona cuando resuelve un problema específico y bien definido en tus operaciones. Ayudo a encontrar esos problemas, construir soluciones e integrarlas con tus sistemas existentes.',
      scopeDescription: 'Los proyectos de IA cubren identificación de casos de uso, selección o desarrollo de modelos, ingeniería de prompts, integración de APIs LLM, preprocesamiento de datos y despliegue en producción.',
      capabilities: [
        'Integración de LLMs con OpenAI y APIs similares.',
        'Procesamiento de lenguaje natural y análisis de texto.',
        'Clasificación, clustering y detección de anomalías.',
        'Preprocesamiento de datos e ingeniería de características.',
        'Integración de modelos en sistemas de producción.',
      ],
      capabilitiesDescription: 'Los entregables de IA son herramientas listas para producción con métricas de precisión claras, código de integración y documentación para mantenimiento continuo.',
      approach: 'Comienzo con tus datos y una pregunta de negocio específica. Luego construyo, valido e integro, manteniendo el foco en resultados prácticos.',
      workProcess: [
        'Identificar el problema de negocio y definir criterios de éxito.',
        'Explorar datos y seleccionar o construir el modelo adecuado.',
        'Validar rendimiento con datos reales.',
        'Integrar en producción y monitorear.',
      ],
    },
  ],
  blogsData: [
    {
      id: '1',
      title: 'Vision Transformers en Visión por Computadora: Avances Recientes, Desafíos y Direcciones Futuras',
      description: 'Un estudio sobre investigación en Vision Transformers de 2023 a 2026, cubriendo arquitecturas eficientes, modelos híbridos CNN-ViT, aprendizaje auto-supervisado, interpretabilidad, escalabilidad y desafíos de despliegue.',
      comment: 'Artículo',
      authorTitle: 'Métodos Avanzados de Aprendizaje Automático',
      create_at: 'Marzo 2026',
    },
    {
      id: '5',
      title: 'Ensayo sobre Desafíos y Tendencias en Vehículos Autónomos',
      description: 'Este ensayo explora los desafíos actuales y tendencias futuras en el desarrollo de vehículos autónomos, abordando aspectos tecnológicos, regulatorios, éticos y de seguridad.',
      comment: 'Ensayo',
      authorTitle: 'Autor',
      create_at: 'Mayo, 2026',
    },
  ],
  projectsData: [
    {
      id: '1',
      title: 'Sistema de Gestión de Gimnasio',
      subTitle: 'Java Desktop / Biometría / POS',
      description: 'Plataforma de escritorio para operaciones de gimnasio: membresías, ventas, inventario, turnos, control de caja y check-in biométrico.',
      stack: 'Java Swing, MySQL, JasperReports, Digital Persona SDK',
    },
    {
      id: '2',
      title: 'Sistema Financiero MAGNO',
      subTitle: 'Finanzas / Plataforma Web Responsive',
      description: 'Plataforma de operaciones financieras para préstamos, cobranza, renovaciones, clientes, sucursales, cierre de caja, gastos, roles y reportes.',
      stack: 'Arquitectura web responsive, acceso por roles, sucursales, reportes',
    },
    {
      id: '3',
      title: 'Sistema de Cobro de Predial',
      subTitle: 'Gobierno Municipal / Plataforma Fiscal',
      description: 'Sistema municipal de predial para registros de propiedades, contribuyentes, configuración fiscal, descuentos, recibos, avisos de adeudo y reportes de caja.',
      stack: 'Registros de propiedad, recibos PDF, exportaciones Excel, configuración fiscal',
    },
    {
      id: '4',
      title: 'Sistema de Lavandería Automatizada',
      subTitle: 'RFID / Arduino / Automatización Retail',
      description: 'Plataforma de lavandería de autoservicio con tarjetas RFID, lavadoras y secadoras conectadas, ventas centralizadas, inventario, turnos y reportes.',
      stack: 'Tarjetas RFID, dispositivos Arduino, impresoras de tickets, escritorio Windows',
    },
    {
      id: '5',
      title: 'Sistema de Gestión de Clínica Dental',
      subTitle: 'Salud / Expedientes de Pacientes',
      description: 'Sistema clínico para expedientes completos de pacientes, datos de contacto, alergias, tratamientos, costos, historial clínico y reportes.',
      stack: 'Expedientes de pacientes, historial de tratamientos, reportes clínicos',
    },
  ],
  experienceData: [
    {
      id: 1,
      position: 'Consultor Senior',
      summary: 'Contribuí a EverWell, plataforma de misión crítica utilizada por agentes de Aflac para inscripción y oferta de productos de seguros.',
      highlights: [
        'Entregué 12+ nuevas funcionalidades siguiendo metodología Scrum.',
        'Automaticé procesos MySQL y reduje el trabajo manual en 70%.',
        'Mejoré el rendimiento de consultas clave hasta un 40%.',
        'Coordiné despliegues a producción sin incidentes críticos.',
      ],
    },
    {
      id: 2,
      position: 'Ingeniero de Software Sr',
      summary: 'Trabajé en Farelogix Pad, plataforma middleware que maneja transacciones entre aerolíneas y el ecosistema Expedia.',
      highlights: [
        'Refactoricé lógica crítica de servicios e incrementé cobertura de pruebas en 30%.',
        'Implementé segmentación de configuración por aerolínea usando archivos YAML.',
        'Reduje tiempos de respuesta a incidentes durante Semanas de Soporte.',
        'Diseñé nuevas operaciones de aerolíneas para integraciones más fluidas.',
      ],
    },
    {
      id: 3,
      position: 'Ingeniero de Software',
      summary: 'Construí soluciones cloud y de automatización para optimizar procesos de manufactura y modernizar aplicaciones legacy.',
      highlights: [
        'Migré 4 aplicaciones legacy a AWS reduciendo tiempos de despliegue al menos 40%.',
        'Diseñé e implementé 6+ microservicios desplegados en AWS ECS.',
        'Construí flujos de notificación a proveedores y procesos batch diarios.',
        'Mejoré rendimiento de APIs hasta 35% mediante refactorización de servicios y SQL.',
      ],
    },
    {
      id: 4,
      position: 'Ingeniero de Software Senior',
      summary: 'Participé en diseño y desarrollo de un sistema de administración legal para adquisición de propiedades y apertura de sucursales.',
      highlights: [
        'Implementé 10+ endpoints REST para automatización de procesos legales.',
        'Construí componentes frontend reutilizables que redujeron el tiempo de desarrollo.',
        'Modelé la base de datos SQL Server desde cero.',
        'Integré Camunda para estandarizar flujos legales internos.',
      ],
    },
    {
      id: 5,
      position: 'Desarrollador Java Senior',
      summary: 'Desarrollé y mantuve sistemas de ventas y envíos de dispositivos utilizados por el equipo comercial a nivel nacional.',
      highlights: [
        'Entregué 25+ funcionalidades para ASD y sistemas internos relacionados.',
        'Lideré un equipo de 3 desarrolladores para entrega funcional y técnica.',
        'Reduje el tiempo de procesamiento de facturas más del 60% con una herramienta personalizada.',
        'Apoyé lanzamientos seguros y reducción de vulnerabilidades con FindBugs y SonarQube.',
      ],
    },
    {
      id: 6,
      position: 'Desarrollador Java',
      summary: 'Brindé soporte y refactorización para aplicaciones internas utilizadas por equipos de call center.',
      highlights: [
        'Refactoricé sistema legacy de Java 1.5 a Java 1.7.',
        'Mejoré el rendimiento del sistema en 40%.',
        'Desarrollé funcionalidades para el sistema Extranet usado por agentes de servicio al cliente.',
        'Corregí 15+ problemas de QA para estabilizar operaciones continuas.',
      ],
    },
  ],
};

export default es;
